(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["motoryva-collection-category-tiles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-category-tiles')) {
    customElements.define('collection-category-tiles', class extends HTMLElement {
      connectedCallback() {
        const search = new URLSearchParams(window.location.search);
        search.delete('page');
        search.delete('filter.p.product_type');
        search.delete('filter.p.tag');
        this.querySelectorAll('[data-category-link]').forEach((link) => {
          const destination = new URL(link.getAttribute('href'), window.location.origin);
          destination.search = search.toString();
          link.href = destination.toString();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["motoryva-collection-sidebar-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('motoryva-collection-nav')) {
    let lvVehicleDataPromise;

    customElements.define(
      'motoryva-collection-nav',
      class extends HTMLElement {
        async connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.brandSelect = this.querySelector('[data-vehicle-brand]');
          this.modelSelect = this.querySelector('[data-vehicle-model]');
          this.manufacturerSelect = this.querySelector('[data-product-manufacturer]');
          this.status = this.querySelector('[data-vehicle-filter-status]');
          const currentTags = this.readJson('[data-current-collection-tags]', []);
          this.currentTags = Array.isArray(currentTags) ? currentTags : [];

          this.brandSelect.addEventListener('change', this.handleBrandChange);
          this.modelSelect.addEventListener('change', this.handleModelChange);
          this.manufacturerSelect.addEventListener('change', this.handleManufacturerChange);

          try {
            const data = await this.loadVehicleData();
            this.brands = data.brands;
            this.populate(this.brandSelect, this.brands, (brand) => brand.name);
            this.restoreSelection();
          } catch (error) {
            this.status.textContent = this.dataset.error;
          }
        }

        disconnectedCallback() {
          this.brandSelect?.removeEventListener('change', this.handleBrandChange);
          this.modelSelect?.removeEventListener('change', this.handleModelChange);
          this.manufacturerSelect?.removeEventListener('change', this.handleManufacturerChange);
        }

        readJson(selector, fallback) {
          try {
            return JSON.parse(this.querySelector(selector)?.textContent || '');
          } catch (error) {
            return fallback;
          }
        }

        loadVehicleData() {
          if (lvVehicleDataPromise) return lvVehicleDataPromise;
          lvVehicleDataPromise = (async () => {
            const payload = Array.from(document.querySelectorAll('[data-vehicle-catalog-payload]'))
              .map((node) => node.textContent.trim())
              .join('');
            if (!payload) throw new Error('Vehicle compatibility data is unavailable');
            const bytes = Uint8Array.from(atob(payload), (character) => character.charCodeAt(0));
            const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
            return JSON.parse(await new Response(stream).text());
          })();
          return lvVehicleDataPromise;
        }

        find(items, id) {
          return items?.find((item) => String(item.id) === String(id));
        }

        populate(select, items, label) {
          while (select.options.length > 1) select.remove(1);
          for (const item of items) select.add(new Option(label(item), item.id));
          select.disabled = items.length === 0;
        }

        reset(select) {
          select.selectedIndex = 0;
          while (select.options.length > 1) select.remove(1);
          select.disabled = true;
        }

        handleBrandChange = () => {
          this.status.textContent = '';
          const brand = this.find(this.brands, this.brandSelect.value);
          this.reset(this.modelSelect);
          if (brand) this.populate(this.modelSelect, brand.models, (model) => model.name);
        };

        handleModelChange = () => {
          this.status.textContent = '';
          const brand = this.find(this.brands, this.brandSelect.value);
          const model = this.find(brand?.models, this.modelSelect.value);
          if (!model) return;
          const count = model.types.reduce((total, type) => total + Number(type.count || 0), 0);
          if (count === 0) {
            this.status.textContent = this.dataset.noParts;
          } else {
            const label =
              count === 1 ? this.dataset.productSingular : this.dataset.productPlural;
            this.status.textContent = `${count} ${label}`;
          }
          this.applyFilters(brand, model);
        };

        handleManufacturerChange = () => {
          this.applyCatalogTagFilter('Fabricant:', this.manufacturerSelect.value);
        };

        restoreSelection() {
          const brandId = this.tagValue('CompatMarque:');
          const modelId = this.tagValue('CompatModele:').split('|').at(-1);
          const brand = this.find(this.brands, brandId);
          if (!brand) return;

          this.brandSelect.value = brand.id;
          this.handleBrandChange();
          const model = this.find(brand.models, modelId);
          if (!model) return;

          this.modelSelect.value = model.id;
          const count = model.types.reduce((total, type) => total + Number(type.count || 0), 0);
          const label =
            count === 1 ? this.dataset.productSingular : this.dataset.productPlural;
          this.status.textContent =
            count > 0 ? `${count} ${label}` : this.dataset.noParts;
        }

        tagValue(prefix) {
          const tag = this.currentTags.find((item) => item.startsWith(prefix));
          return tag ? tag.slice(prefix.length) : '';
        }

        applyCatalogTagFilter(prefix, selectedTag) {
          const updatedTags = this.currentTags.filter((tag) => !tag.startsWith(prefix));
          if (selectedTag) updatedTags.push(selectedTag);
          this.navigateToTags(updatedTags);
        }

        navigateToTags(tags) {
          const tagPath = tags.map((tag) => encodeURIComponent(tag)).join('+');
          const collectionPath = tagPath
            ? `${this.dataset.collectionUrl}/${tagPath}`
            : this.dataset.collectionUrl;
          const destination = new URL(collectionPath, window.location.origin);
          const currentSearch = new URLSearchParams(window.location.search);
          currentSearch.delete('page');
          currentSearch.delete('filter.p.tag');
          destination.search = currentSearch.toString();
          window.location.assign(destination);
        }

        applyFilters(brand, model) {
          const preservedTags = this.currentTags.filter(
            (tag) =>
              !tag.startsWith('CompatMarque:') &&
              !tag.startsWith('CompatModele:') &&
              !tag.startsWith('CompatType:') &&
              !tag.startsWith('VehiculeMarque:') &&
              !tag.startsWith('VehiculeModele:') &&
              !tag.startsWith('VehiculeVersion:') &&
              !tag.startsWith('VehiculeMoteur:'),
          );
          const vehicleTags = [
            `CompatMarque:${brand.id}`,
            `CompatModele:${brand.id}|${model.id}`,
          ];
          this.navigateToTags([...preservedTags, ...vehicleTags]);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-filter"] && !Shopify.designMode) return;
  try {
    class MotoryvaPriceSlider extends HTMLElement {
    connectedCallback() {
      this.minRange = this.querySelector('[data-range-min]');
      this.maxRange = this.querySelector('[data-range-max]');
      this.track = this.querySelector('.price-facet__slider-track');
      this.priceFacet = this.closest('price-facet-component');
      this.minInput = this.priceFacet?.querySelector('[ref="minInput"]');
      this.maxInput = this.priceFacet?.querySelector('[ref="maxInput"]');

      if (!this.minRange || !this.maxRange || !this.track || !this.minInput || !this.maxInput) return;

      this.currency = this.dataset.currency || 'EUR';
      this.rangeMaximum = Number(this.maxRange.dataset.limit) || 1;
      this.step = Number(this.maxRange.dataset.step) || 100;
      this.fractionDigits = new Intl.NumberFormat(document.documentElement.lang || 'fr-BE', {
        style: 'currency',
        currency: this.currency,
      }).resolvedOptions().maximumFractionDigits;

      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointermove', this.handlePointerMove);
      this.addEventListener('pointerup', this.handlePointerUp);
      this.addEventListener('pointercancel', this.handlePointerUp);
      this.addEventListener('keydown', this.handleKeyDown);
      this.addEventListener('keyup', this.handleKeyUp);
      this.updateTrack();
    }

    disconnectedCallback() {
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('pointerup', this.handlePointerUp);
      this.removeEventListener('pointercancel', this.handlePointerUp);
      this.removeEventListener('keydown', this.handleKeyDown);
      this.removeEventListener('keyup', this.handleKeyUp);
    }

    handlePointerDown = (event) => {
      if (!(event.target instanceof Element)) return;

      const requestedHandle = event.target.closest('.price-facet__range');
      const pointerValue = this.valueFromPointer(event);
      this.activeHandle = requestedHandle || this.closestHandle(pointerValue);
      this.activeHandle.classList.add('is-active');
      this.setPointerCapture(event.pointerId);
      this.setHandleValue(this.activeHandle, pointerValue);
      event.preventDefault();
    };

    handlePointerMove = (event) => {
      if (!this.activeHandle || !this.hasPointerCapture(event.pointerId)) return;
      this.setHandleValue(this.activeHandle, this.valueFromPointer(event));
    };

    handlePointerUp = (event) => {
      if (!this.activeHandle) return;
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
      this.activeHandle.classList.remove('is-active');
      this.activeHandle = null;
      this.commitFilter();
    };

    handleKeyDown = (event) => {
      if (!(event.target instanceof HTMLButtonElement)) return;
      if (!event.target.matches('.price-facet__range')) return;

      const currentValue = Number(event.target.dataset.value);
      let nextValue = currentValue;

      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') nextValue -= this.step;
      if (event.key === 'ArrowRight' || event.key === 'ArrowUp') nextValue += this.step;
      if (event.key === 'PageDown') nextValue -= this.step * 10;
      if (event.key === 'PageUp') nextValue += this.step * 10;
      if (event.key === 'Home') nextValue = 0;
      if (event.key === 'End') nextValue = this.rangeMaximum;
      if (nextValue === currentValue) return;

      event.preventDefault();
      this.keyboardChanged = true;
      this.setHandleValue(event.target, nextValue);
    };

    handleKeyUp = (event) => {
      if (!(event.target instanceof HTMLButtonElement)) return;
      if (!this.keyboardChanged) return;

      this.keyboardChanged = false;
      this.commitFilter();
    };

    valueFromPointer(event) {
      const trackBounds = this.track.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (event.clientX - trackBounds.left) / trackBounds.width));
      return Math.round((ratio * this.rangeMaximum) / this.step) * this.step;
    }

    closestHandle(value) {
      const minDistance = Math.abs(value - Number(this.minRange.dataset.value));
      const maxDistance = Math.abs(value - Number(this.maxRange.dataset.value));
      return minDistance <= maxDistance ? this.minRange : this.maxRange;
    }

    setHandleValue(handle, value) {
      const minValue = Number(this.minRange.dataset.value);
      const maxValue = Number(this.maxRange.dataset.value);
      let constrainedValue = Math.min(this.rangeMaximum, Math.max(0, value));

      if (handle === this.minRange) constrainedValue = Math.min(constrainedValue, maxValue);
      if (handle === this.maxRange) constrainedValue = Math.max(constrainedValue, minValue);

      handle.dataset.value = String(constrainedValue);
      this.syncTextInputs();
      this.updateTrack();
    }

    commitFilter() {
      this.syncTextInputs();
      this.minInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    syncTextInputs() {
      const minValue = Number(this.minRange.dataset.value);
      const maxValue = Number(this.maxRange.dataset.value);

      this.minInput.value = minValue > 0 ? this.formatMinorUnits(minValue) : '';
      this.maxInput.value = maxValue < this.rangeMaximum ? this.formatMinorUnits(maxValue) : '';
    }

    formatMinorUnits(value) {
      const divisor = 10 ** this.fractionDigits;
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-BE', {
        useGrouping: false,
        minimumFractionDigits: 0,
        maximumFractionDigits: this.fractionDigits,
      }).format(value / divisor);
    }

    updateTrack() {
      const minValue = Number(this.minRange.dataset.value);
      const maxValue = Number(this.maxRange.dataset.value);
      const start = (minValue / this.rangeMaximum) * 100;
      const end = (maxValue / this.rangeMaximum) * 100;
      const divisor = 10 ** this.fractionDigits;

      this.style.setProperty('--range-start', `${start}%`);
      this.style.setProperty('--range-end', `${end}%`);
      this.minRange.setAttribute('aria-valuenow', String(minValue / divisor));
      this.maxRange.setAttribute('aria-valuenow', String(maxValue / divisor));
      this.minRange.setAttribute('aria-valuetext', `${this.formatMinorUnits(minValue)} ${this.currency}`);
      this.maxRange.setAttribute('aria-valuetext', `${this.formatMinorUnits(maxValue)} ${this.currency}`);
    }
  }

  if (!customElements.get('motoryva-price-slider')) {
    customElements.define('motoryva-price-slider', MotoryvaPriceSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
